<div class="empty-state" [class]="orientation()">
  <div class="wrapper">
    <div class="animation">
      <div
        class="outer"
        [style.width.px]="badgeSize()"
        [style.height.px]="badgeSize()"
      >
        <div class="inner">
          <ng-content></ng-content>
        </div>
      </div>

      @if (pulse()) {
        @let circleSize = size() - 4;
        <div
          class="circle"
          [style.width.px]="circleSize"
          [style.height.px]="circleSize"
        ></div>
      }
    </div>

    <div class="text-content">
      @if (heading(); as heading) {
        <p class="f-body-l f-medium">{{ heading | translate }}</p>
      }

      @if (description(); as description) {
        <p
          class="description f-body-s f-muted"
          [innerHTML]="description | translate"
        ></p>
      }

      @if (link(); as link) {
        <onyx-link
          class="link"
          [color]="link.color ?? 'gray'"
          [font]="link.font ?? 'f-body-xs f-medium'"
          (click)="link.callback?.(); $event.stopPropagation()"
        >
          {{ link.label | translate }}
        </onyx-link>
      }
    </div>

    @if (action(); as action) {
      <onyx-button
        variant="outlined"
        [size]="32"
        [leftIcon]="action.leftIcon"
        (click)="action.callback(); $event.stopPropagation()"
      >
        {{ action.label | translate }}
      </onyx-button>
    }
  </div>
</div>
